export default __webpack_public_path__ + "static/media/ic_trophy.52b8bee6.png";